<template>
  <section class="login">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper">
        <div class="content-wrapper d-flex align-items-center auth">
          <div class="row w-100">
            <div
              class="login-form-width col-lg-5 col-md-8 col-sm-9 col-xs-10 mx-auto"
            >
              <div class="auth-form-light text-left p-5">
                <div class="brand-logo">
                  <img src="../assets/images/onlypay/logo.png" />
                </div>
                <h4>Olá, bem vindo de volta.</h4>
                <h6 class="font-weight-light">Faça login para continuar.</h6>
                <div class="pt-3">
                  <div class="mt-3">
                    <button
                      class="btn btn-block btn-gradient-success btn-lg font-weight-medium auth-form-btn text-white"
                      :is-loading="isLoadingLogin"
                      :disabled="isLoadingLogin"
                      @click="loginWithMicrosoft"
                    >
                      <div
                        v-if="isLoadingLogin"
                        class="spinner-border spinner-border-sm mr-2"
                      ></div>
                      <span v-if="isLoadingLogin">Entrando</span>
                      <span v-else>
                        <img
                          src="../assets/images/file-icons/icon-microsoft.svg"
                          alt="Microsoft"
                          class="mr-2"
                          style="width: 20px; height: 20px; vertical-align: middle;"
                        />
                        Entrar com Microsoft
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getCookie, removeCookie } from '@/helpers/cookie';

export default {
  name: 'LoginForm',
  data() {
    return {
      isLoadingLogin: false,
      expiredToken: getCookie('olp_csl_expired_token'),
    };
  },
  methods: {
    async loginWithMicrosoft() {
      this.isLoadingLogin = true;

      try {
        // Redirect não retorna promise - a página é redirecionada imediatamente
        await this.$loginWithMicrosoft();
        // Não chega aqui - a página é redirecionada para Microsoft
      } catch (error) {
        // Tratar apenas erros raros de inicialização do redirect
        this.isLoadingLogin = false;
        this.$swal.fire({
          title: 'Erro na autenticação',
          html: `Erro ao iniciar login: ${error.message || 'Erro desconhecido'}. <br/> Por favor, tente novamente.`,
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      }
    },
  },
  beforeMount() {
    if (this.expiredToken) {
      this.$swal.fire({
        title: 'Sessão expirada!',
        html: 'Sua sessão expirou. Por favor, faça login novamente.',
        icon: 'error',
        confirmButtonText: 'Ok',
      }).then((result) => {
        if (result.isConfirmed) {
          removeCookie('olp_csl_expired_token');
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.login {
  .content-wrapper {
    padding: 0;
  }
  .login-form-width {
    max-width: 500px;
    @media (min-width: 992px) and (max-width: 1200px) {
      width: 50% !important;
    }
  }
  .row {
    margin: auto !important;
  }
}
</style>
